import { TeButton } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { PlaceholderContainer } from '@topcon/topcon-utils';

interface Props {
  onClick: () => void;
}

function EmptyCompanies({ onClick }: Props) {
  const { t } = useTranslation('companies');

  return (
    <PlaceholderContainer
      grow
      icon="business"
      text={t('list.noCompanies')}
      secondaryText={t('clickButtonToAddOne')}
      backgroundColor="background.secondary"
    >
      <TeButton text={t('list.createCompany')} size="s" teclick={onClick} />
    </PlaceholderContainer>
  );
}

export default EmptyCompanies;
